import http from '../_http'

const dashboard = {
  allDashboard: (m) => { return http.post(`manager/wsfinder/dashboard`, m); },
  monthDashboard: (m) => { return http.get(`manager/wsfinder/dashboard/month`, m); },
  weekDashboard: (m) => { return http.get(`manager/wsfinder/dashboard/week`, m); },
}

export default dashboard

export { dashboard }